<div class="row justify-content-center  full-hight login ">
  <div class="col-9 col-md-5 logincard">
    <mat-card class="row ">
      <div class="col-12 align-self-center">
        <router-outlet></router-outlet>
      </div>
    </mat-card>
  </div>
</div>
